module.exports = __webpack_public_path__ + "media/src/assets/images/lesley-acc62138caf8bad6ff9bcbcfda9c6870.png";